import { twMerge } from "tailwind-merge";
import errorIcon from "../../assets/Icons/ErrorIcon.svg"
import NotFoundIcon from '../../assets/Icons/notFound.svg'

function FetchingError({
  error,
  onRetry,
  isEmptyRecords = false,
  message,
  fetchingErrorClassName = "",
  fetchingErrorContainerClassName = ""
}) {
  const isNotFoundState = error?.code == 404 || (!error && isEmptyRecords);

  return (
    <div className={twMerge('flex flex-col items-center text-gray justify-center h-[300px] space-y-4 mb-10', fetchingErrorContainerClassName)}>
      <img 
        className={twMerge('w-[180px] h-[180px] md:w-[250px] md:h-[272px]', fetchingErrorClassName)} 
        src={isNotFoundState ? NotFoundIcon : errorIcon} 
        alt='Error Icon' 
      />
      {onRetry && isNotFoundState &&
      <button
        onClick={onRetry}
        className='w-[150px] font-poppins py-2 bg-slate-300 text-white rounded-md hover:bg-[#bbc4ce] transition'
      >
        Clear Filters
      </button>
      }
      <p className="text-inter tracking-wide ">
        {isNotFoundState ? (message || "No results found") : "Something Went Wrong...."}
      </p>
    </div>
  );
}
export default FetchingError;
